import type { DialPadValue } from 'features/dial-pad/interfaces';

export const normalizeKeyboardValue = (keyboardValue: string): DialPadValue => {
  if (keyboardValue === '/') {
    return '#';
  }

  return keyboardValue as DialPadValue;
};
